import PropTypes from 'prop-types';
import { Box, ButtonBase, Typography } from '@material-ui/core';
import React from 'react';
import { appColors } from 'styles/colors';

export default function SegmentedControl(props) {
  const { options, value, onChange, fullWidth, dense, style } = props;

  return (
    <Box
      display="inline-flex"
      style={{
        background: appColors.background.level1,
        borderRadius: 8,
        padding: 4,
        width: fullWidth ? '100%' : undefined,
        ...style,
      }}>
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <ButtonBase
            key={option.value}
            onClick={() => onChange(option.value)}
            aria-pressed={selected}
            style={{
              flex: fullWidth ? 1 : undefined,
              borderRadius: 6,
              padding: dense ? '4px 12px' : '8px 20px',
              background: selected ? appColors.light.level1 : 'transparent',
              boxShadow: selected ? '0 1px 3px rgba(0, 0, 0, 0.12)' : 'none',
              transition: 'background 120ms ease',
            }}>
            <Typography
              variant="body2"
              noWrap
              style={{
                fontWeight: 500,
                color: selected ? appColors.primary : appColors.dark.level3,
              }}>
              {option.label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
}

SegmentedControl.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  dense: PropTypes.bool,
  style: PropTypes.object,
};
